<template>
  <div>

  <full-page ref="fullpage" id="fullpage"  :options="options">
  
    <!-- Intro -->
    <div class="section bg-rr-eyes">
        <app-header></app-header>
        <v-layout
          column
          fill-height>
            <v-flex xs12 md5 order-xs2 order-md1 res-push>
              <v-layout
                column
                fill-height
                align-center
                justify-center
                class="text-over-image-side bright">
                <h1 class="text-xs-center">{{ $t("rrEyesPage.firstSection.header") }}</h1>
                <span/>
                <p class="text-xs-center">{{ $t("rrEyesPage.firstSection.paragraph") }}</p>
              </v-layout>
            </v-flex>
            <v-flex xs12 md1 order-xs1/>
            <v-flex xs12 md5 order-xs1/>
            <v-flex xs12 md1 order-xs1/>
        </v-layout>
        <div class='icon-scroll ' style="bottom:20px;"></div>
    </div>


     <!-- rr eyes -->
    <div class="section pan-dark fp-auto-height-responsive pan-bg-dark">
      <v-container fluid fill-height class="pa-0">
        <v-layout row wrap align-content-center align-center>
          <v-flex xs12 md6 fill-height order-xs2 order-md1 class="bg-rr-eyes-square pan-min-height"></v-flex>
          
          <v-flex xs12 md6 fill-height order-xs1 order-md2>
            <v-layout 
              column
              align-center
              justify-center
              fill-height
              class="pan-min-height bg-black-marble">
              <div class="pa-4 mb-4 text-xs-center pan-txt-restrict pan-margin-center">
                <div class="special-rr-header">
                  <img src="../assets/images/all/rr-eyes.png" class="header-title-img" alt="">
                </div>

                <p>{{ $t("rrEyesPage.secondSection.paragraph1") }}</p>
                
                <p>{{ $t("rrEyesPage.secondSection.paragraph2") }}</p>
                <div class="mt-5 mb-1"><a :href="$core.productlinks.rrEyes" target="_blank"><v-btn outline large color="white">{{ $t("cta['SHOP NOW']") }}</v-btn></a>
                </div>
              </div>
            </v-layout>

          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <!-- Third -->
    <div class="section fp-auto-height-responsive">
      <v-container fluid fill-height class="pa-0 pan-bg-dark">
        <v-layout row wrap fill-height align-content-center align-center>
          <v-flex xs12 md6 pan-dark fill-height>
            
            <v-layout fill-height align-center>
              <v-flex>
                  
                  <div class="pa-4 mb-4 text-xs-center pan-txt-restrict pan-margin-center">
                  <h1>{{ $t("rrEyesPage.thirdSection.header") }}</h1>

                    <p>{{ $t("rrEyesPage.thirdSection.paragraph1") }}</p>

                    <p>{{ $t("rrEyesPage.thirdSection.paragraph2") }}</p>

                    <p><a :href="'#' + $t('rrOriginalPage.tooltips.five')" style="color:white;border-bottom:1px solid white;font-size:12px;margin-bottom:-20px;text-transform:uppercase">{{ $t("rrOriginalPage.thirdSection.proof") }}</a></p>

                  <div class="mt-5 mb-1"><a :href="$core.productlinks.rrEyes" target="_blank"><v-btn outline large color="white">{{ $t("cta['SHOP NOW']") }}</v-btn></a></div>
              
                </div>
              </v-flex>
            </v-layout>

          </v-flex>

          <v-flex xs12 md6 fill-height class="pan-hide-overflow pan-bg-bright">
            <v-container fill-height class="bg-rr-eyes2 pan-min-height"/>
        
          </v-flex>
        </v-layout>
      </v-container>
    </div>


    <!-- Statistics Section -->
    <div class=" section pan-bg-dark pan-dark fp-auto-height-responsive bg-black-marble pan-min-height">
      
        <v-layout
          column
          fill-height
          align-center
          justify-center>
  
          <v-flex xs4 class="ma-3" style="display:flex;align-items:center;justify-content:center;">
          </v-flex>
          
          <v-flex xs4>
            <h1 class="text-xs-center mb-5">{{ $t("rrEyesPage.stats.header") }}</h1>
            <v-layout row wrap>
              <v-flex xs12 md4 class="pa-2">
                <app-percentage :radius="120" :progress="percentage.one" :stroke="6"></app-percentage>
                <p class="pan-txt-s pan-percentage-text">{{ $t("rrEyesPage.stats.first") }}</p>
              </v-flex>

              <v-flex xs12 md4 class="pa-2">
                <app-percentage :radius="120" :progress="percentage.two" :stroke="6"></app-percentage>
                <p class="pan-txt-s pan-percentage-text">{{ $t("rrEyesPage.stats.second") }}</p>
              </v-flex>

              <v-flex xs12 md4 class="pa-2">
                <app-percentage :radius="120" :progress="percentage.three" :stroke="6"></app-percentage>
                <p class="pan-txt-s pan-percentage-text">{{ $t("rrEyesPage.stats.third") }}</p>
              </v-flex>      
            </v-layout>
            <p class="pan-txt-xs text-xs-center mt-5 pt-2 pan-txt-restrict" style="margin:20px auto;">{{ $t("rrEyesPage.stats.asterix") }}</p>
          </v-flex>

          <v-flex 
            xs4 
            class="ma-2 pb-5 mb-5"
            style="display:flex;flex-direction:column;align-items:center;justify-content:center;">
        
            <a class="mt-5" :href="$core.productlinks.rrEyes" target="_blank"><v-btn outline large color="white">{{ $t("cta['SHOP NOW']") }}</v-btn></a>
          </v-flex>
  
        </v-layout>
  
    </div>

    <!-- Proof2 -->
    <div class="section pan-dark fp-auto-height-responsive pan-bg-dark">
      <v-container fluid fill-height class="pa-0">
        <v-layout row wrap align-content-center align-center>
          <v-flex xs12 md6 fill-height order-xs2 order-md1 class="bg-glass pan-min-height"></v-flex>
          
          <v-flex xs12 md6 fill-height order-xs1 order-md2>
            <v-layout 
              column
              align-center
              justify-center
              fill-height
              class="bg-black-marble pan-min-height">
              <div class="pa-4 mb-4 text-xs-center pan-txt-restrict pan-margin-center pan-proof">
                <h1>{{ $t("rrEyesPage.proof.header") }}</h1>

                    <p>
                      <span>{{ $t("rrEyesPage.proof.first.text") }}</span>
                      <span>{{ $t("rrEyesPage.proof.first.name") }}</span>
                      <span>{{ $t("rrEyesPage.proof.first.reference") }}</span>
                    </p>
                    
                    <div style="padding-top:20px;">
                        <p>
                        <span>{{ $t("rrEyesPage.proof.second.text") }}</span>
                        <span>{{ $t("rrEyesPage.proof.second.name") }}</span>
                        <span>{{ $t("rrEyesPage.proof.second.reference") }}</span>
                        </p>
                    </div>

                    <div style="padding-top:20px;">
                      <p>
                      <span>{{ $t("rrEyesPage.proof.third.text") }}</span>
                      <span>{{ $t("rrEyesPage.proof.third.name") }}</span>
                      <span>{{ $t("rrEyesPage.proof.third.reference") }}</span>
                      </p>
                    </div>

                    <div style="padding-top:20px;">
                      <p>
                        <span>{{ $t("rrEyesPage.proof.fourth.text") }}</span>
                        <span>{{ $t("rrEyesPage.proof.fourth.name") }}</span> 
                        <span>{{ $t("rrEyesPage.proof.fourth.reference") }}</span>
                      </p>
                    </div>

                <div class="mt-5 mb-1"><a class="mt-5" :href="$core.productlinks.moreStudies" target="_blank"><v-btn outline large color="white">{{ $t("rrEyesPage.proof.cta") }}</v-btn></a>
                </div>
              </div>
            </v-layout>

          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <!-- End of Proof2 -->

    <!-- Shop The range -->
    <div class="section bg-rr-range pan-dark">
      <v-layout
        column
        fill-height>
        <v-layout
          column
          align-center
          justify-center 
          class="pan-equal text-over-image bright text-xs-center">
          <h1 class="text-xs-center">{{$t("rrEyesPage.sixthSection.header")}}</h1>
        </v-layout>
        <v-layout class="pan-equal"/>
        <v-layout 
          column
          align-center
          justify-center
          class="pan-equal text-over-image-reverse">
          <a :href="$core.productlinks.rrRange" target="_blank" ><v-btn  outline large color="white">{{ $t("cta['DISCOVER NOW']") }}</v-btn></a>
        </v-layout>
      </v-layout>
    </div>
    

      <app-footer class="fp-auto-height" :top="this.$t('rrEyesPage.tooltips.two')"></app-footer>
    </full-page>


  </div>
</template>

<script>
  import appHeader  from '../components/app-header.vue'
  import appFooter  from '../components/app-footer.vue'
  import appPercentage from '../components/app-percentage.vue'

  export default {
    data: function(){
      return {
        percentage:{
          one:0,
          two:0,
          three:0
        },
        options: {
          responsiveWidth: 1350,
          anchors:[
            this.$t('rrEyesPage.tooltips.two'),
            this.$t('rrEyesPage.tooltips.one'),
            this.$t('rrEyesPage.tooltips.three'),
            this.$t('rrEyesPage.tooltips.four'),
            this.$t('rrEyesPage.tooltips.five'),
            this.$t('rrEyesPage.tooltips.six')
          ],
          navigation: true,
          navigationTooltips: [
            this.$t('rrEyesPage.tooltips.two'),
            this.$t('rrEyesPage.tooltips.one'),
            this.$t('rrEyesPage.tooltips.three'),
            this.$t('rrEyesPage.tooltips.four'),
            this.$t('rrEyesPage.tooltips.five'),
            this.$t('rrEyesPage.tooltips.six')
          ],
          showActiveTooltip: true,
          verticalCentered: false,
          fitToSection:true,
          //events
          onLeave: this.onLeave,
          // licence Key
          licenseKey: this.$licenceKey
        }
      }
    },
    components: {
      appHeader,
      appFooter,
      appPercentage
    },
    methods:{
      onLeave: function(origin, destination, direction){
        var percentagesthis = this;
        if(destination.index == 3){
          setTimeout(function(){
            percentagesthis.percentage.one = 88;
          }, 500);
          setTimeout(function(){
            percentagesthis.percentage.two = 92;
          }, 1000);
          setTimeout(function(){
            percentagesthis.percentage.three = 80;
          }, 1500);
        }
         else {
          setTimeout(function(){
            percentagesthis.percentage.one = 0;
            percentagesthis.percentage.two = 0;
            percentagesthis.percentage.three = 0;
          }, 500);
        }
      }
    }
  }
 
</script>

